export function formatPhoneMasked(phone: string): string {
    if (!phone) return '';
    const digits = phone.replace(/\D/g, '');
    if (digits.length === 10 && digits.startsWith('0')) {
        return `+66 * ** ** ${digits.slice(-4)}`;
    }
    return `* ** ** ${digits.slice(-4)}`;
}

// Unformat a number-like string by removing commas and trimming spaces
export const unformatNumberString = (val: string) => val.replace(/,/g, '').trim();

// Format with commas while preserving decimals (no rounding) and trailing dot during typing
export const formatWithCommasPreserveDecimals = (val: string | number) => {
  if (val === null || val === undefined || val === '-') return '';
  const s = String(val).replace(/,/g, '').trim();
  if (!s) return '';

  // Handle leading sign
  let sign = '';
  let body = s;
  if (s[0] === '+' || s[0] === '-') {
    sign = s[0] === '-' ? '-' : '';
    body = s.slice(1);
  }

  const hasTrailingDot = body.endsWith('.');
  const parts = body.split('.');
  const intRaw = parts[0] || '0';
  const decRaw = parts[1] ?? undefined; // may be undefined

  // Add commas to integer part
  const intFormatted = intRaw.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  if (hasTrailingDot) {
    return sign + intFormatted + '.'; // preserve trailing '.' while typing
  }
  if (decRaw !== undefined) {
    return sign + intFormatted + (decRaw !== '' ? '.' + decRaw : '');
  }
  return sign + intFormatted;
};

/**
 * Format a number or numeric string with commas for display.
 */
export const formatNumberWithCommas = (value: string | number | null | undefined): string => {
  if (value === '' || value === null || value === undefined) return '';
  const num = Number(value);
  return isNaN(num) ? '' : num.toLocaleString('en-US');
};

/**
 * Parse a formatted number string (e.g. "1,234.56") into a numeric value or empty string.
 */
export const parseNumberInput = (input: string): number | '' => {
  const raw = input.replace(/,/g, '');
  if (!/^\d*\.?\d*$/.test(raw)) return '';
  return raw === '' ? '' : Number(raw);
};

